enum CustomerViewType {
    Guest = 'guest',
    Login = 'login',
}

export default CustomerViewType;
